import { colors } from '../../colors';
var socialFeed = {
  postTextColor: colors.onyx,
  primaryColor: colors.cerulean,
  feedBgColor: colors.white,
  headlineUppercase: false,
  subHeadlineUppercase: true
};
export default socialFeed;